import React from "react";

import useFarms from "../../hooks/use-farms.js";
import useStrategicAccounts from "../../hooks/use-strategic-accounts.js";

import { default as Rep } from "../main/reports.js";

const Reports = () => {
	const { farms, farmsLoading } = useFarms();

	const {
		strategicAccounts,
		strategicAccountsLoading,
		strategicAccountsError,
		refetchStrategicAccounts,
	} = useStrategicAccounts();

	const view = (
		<Rep
			strategicAccounts={strategicAccounts}
			strategicAccountsLoading={strategicAccountsLoading}
			strategicAccountsError={strategicAccountsError}
			refetchStrategicAccounts={refetchStrategicAccounts}
			farms={farms}
			farmsLoading={farmsLoading}
		/>
	);

	return <>{view}</>;
};

export default Reports;
